var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/24/phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60012 4C5.16612 4 4.00012 5.166 4.00012 6.6C4.00012 13.988 10.0111 20 17.4001 20C18.8331 20 20.0001 18.834 20.0001 17.4C20.0001 17.289 19.9931 17.18 19.9791 17.072L15.3591 16.012C15.2671 16.188 15.1661 16.379 15.0741 16.557C14.6181 17.427 14.2881 18.059 13.4461 17.72C10.1401 16.56 7.44112 13.86 6.26612 10.514C5.90912 9.729 6.58912 9.373 7.45112 8.923C7.62612 8.831 7.81512 8.732 7.98812 8.642L6.92812 4.021C6.81712 4.007 6.70912 4 6.60012 4M17.4001 22C8.90812 22 2.00012 15.092 2.00012 6.6C2.00012 4.063 4.06312 2 6.60012 2C6.86012 2 7.11712 2.022 7.36612 2.065C7.60912 2.104 7.85312 2.166 8.09112 2.248C8.41612 2.361 8.66112 2.634 8.73812 2.97L10.1071 8.934C10.1831 9.262 10.0881 9.606 9.85412 9.85C9.71812 9.992 9.71512 9.995 8.47512 10.644C9.47912 12.818 11.2241 14.557 13.3541 15.527C14.0041 14.286 14.0081 14.282 14.1501 14.146C14.3941 13.912 14.7401 13.821 15.0661 13.893L21.0311 15.262C21.3661 15.339 21.6391 15.583 21.7511 15.908C21.8331 16.144 21.8951 16.388 21.9361 16.639C21.9781 16.886 22.0001 17.142 22.0001 17.4C22.0001 19.937 19.9361 22 17.4001 22",
    fill: "#EE5F10"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.63a833e7.svg";
export { ForwardRef as ReactComponent };